// extracted by mini-css-extract-plugin
export default {"container":"Fu-z","heading":"Gu-z","text":"Hu-z","info":"Iu-z","link":"Ju-z","fullMaxWidth":"Ku-z"};